/**
 * Sector color palette + lookup. Pure data + helper, no React.
 *
 * Used everywhere a stock is rendered (3D scatter, 2D scatter, splash, table,
 * tooltip, detail panel, sector legend). Single source of truth — adding a new
 * sector means editing this file only.
 */

export const SECTOR_COLORS: Record<string, string> = {
  'Technology': '#818cf8',
  'Health Care': '#f472b6',
  'Financials': '#fbbf24',
  'Financial Services': '#fbbf24',
  'Insurance': '#eab308',
  'Consumer Discretionary': '#34d399',
  'Industrials': '#60a5fa',
  'Communication Services': '#a78bfa',
  'Consumer Staples': '#2dd4bf',
  'Energy': '#fb923c',
  'Utilities': '#a3e635',
  'Real Estate': '#f87171',
  'Materials': '#c4b5fd',
  'Basic Materials': '#c4b5fd',
  'Consumer Defensive': '#2dd4bf',
  'Consumer Cyclical': '#34d399',
  'Healthcare': '#f472b6',
  'Foreign': '#e2e8f0',
  'Canada': '#d52b1e',
  // Portfolio super-planet (2026-05-22): hot sun orange. The Portfolio
  // Visualizer's "Combined" mode renders the whole book as a single
  // sphere at the weighted-avg coordinates with this color so it reads
  // as a burning sun against the dim universe planets.
  'Portfolio': '#f97316',
}

const FALLBACK = '#94a3b8'

export function getSectorColor(sector: string): string {
  return SECTOR_COLORS[sector] ?? FALLBACK
}
